module.exports = __webpack_public_path__ + "media/images/icon-bookmark-47cc8ee0354d1804834058f7c6b080b7.svg";